module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sitemap"
  }, [(_vm.$slots.sidebar) ? _c('div', {
    staticClass: "sitemap__sidebar"
  }, [_vm._t("sidebar")], 2) : _vm._e(), _c('section', {
    staticClass: "sitemap__content"
  }, [(_vm.hasTitle) ? _c('div', {
    staticClass: "sitemap__title"
  }, [_vm._t("title", [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])], 2) : _vm._e(), (_vm.hasDesc) ? _c('div', {
    staticClass: "sitemap__desc"
  }, [_vm._t("default", [_vm._v("\n        " + _vm._s(_vm.desc) + "\n      ")])], 2) : _vm._e(), _c('ul', {
    staticClass: "sitemap__map",
    class: {
      'sitemap__map_padded': _vm.hasTitle || _vm.hasDesc
    }
  }, _vm._l((_vm.map), function(section) {
    return _c('li', {
      key: section.code,
      staticClass: "sitemap__section"
    }, [_c('router-link', {
      staticClass: "sitemap__link",
      attrs: {
        "to": section.to
      }
    }, [_vm._v("\n          " + _vm._s(section.text) + "\n        ")]), (section.children && section.children.length > 0) ? _c('ul', {
      staticClass: "sitemap__sub-map"
    }, _vm._l((section.children), function(subsection) {
      return _c('li', {
        key: subsection.code,
        staticClass: "sitemap__sub-section"
      }, [_c('router-link', {
        staticClass: "sitemap__sub-link",
        attrs: {
          "to": subsection.to
        }
      }, [_vm._v("\n              " + _vm._s(subsection.text) + "\n            ")])], 1)
    }), 0) : _vm._e()], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ccf99c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SiteMap.vue
// module id = c728264e87aabae03c88
// module chunks = 0